import { Injectable } from "@angular/core";
import { normalize } from "normalizr";

@Injectable()
export class NormalizationService {

    /**
     *
     * @param data
     * @param schema
     * @todo
     *  add (entity: string) argument to this method and use it to create
     *  an instance of the entity
     */
    normalize(data, schema): any {
        let n;
        let e: any;

        if (Array.isArray(data)) {
            e = {};
            data.forEach(item => {
                const x = this.normalize(item, schema);
                Object.keys(x).forEach(key => {

                    if (!e[key]) {
                        e[key] = {ids: [], entities: {}};
                    }

                    e[key].ids = [
                        ...e[key].ids,
                        ...x[key].ids.filter(id => e[key].ids.indexOf(id) === -1)
                    ];

                    e[key].entities = {
                        ...e[key].entities,
                        ...x[key].entities
                    };
                });
            });
            return e;
        }

        e = {};
        n = normalize(data, schema);

        Object.keys(n.entities).forEach(key => {
            e[key] = this._normalizeHelper(n.entities[key]);
        });
        return e;
    }

    protected _normalizeHelper(entities): any {
        const store = {
            ids: [],
            entities: {}
        };
        Object.keys(entities).forEach(key => {
            store.ids.push(key);
            store.entities[key] = entities[key];
        });
        return store;
    }

}



// WEBPACK FOOTER //
// ./src/core/services/normalization/normalization.service.ts